var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomAct1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.63 7.24L15.34 0.9C13.77 -0.3 11.58 -0.3 10.01 0.9L1.71997 7.24C0.34997 8.28 -0.28003 10.04 0.10997 11.72L2.25997 21.06C2.72997 23.06 4.48997 24.46 6.53997 24.46H18.81C20.86 24.46 22.63 23.06 23.09 21.06L25.24 11.72C25.63 10.04 25 8.28 23.63 7.24ZM16.32 14.75L13.83 16.47C13.49 16.71 13.08 16.83 12.68 16.83C12.28 16.83 11.87 16.71 11.52 16.47L9.02997 14.75C8.61997 14.46 8.51997 13.9 8.80997 13.49C9.08997 13.09 9.64997 12.98 10.06 13.27L12.55 15C12.62 15.05 12.73 15.05 12.8 15L15.29 13.27C15.7 12.98 16.26 13.09 16.55 13.49C16.83 13.9 16.73 14.46 16.32 14.75Z",
    fill: "url(#paint0_linear_21_243)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_243",
    x1: -0.0000302874,
    y1: 12.23,
    x2: 25.36,
    y2: 12.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F8AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39DEFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.36,
    height: 24.46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomAct1);
export default __webpack_public_path__ + "static/media/HomAct_1.99e5bf49eec0afe38c5e24e3828da8d2.svg";
export { ForwardRef as ReactComponent };